import axios from "axios";
import { getBaseUrl } from "./config";

export const getStatics = async () => {
  const response = await axios.get(`${getBaseUrl()}/statics/all`);
  return response.data;
};

export const getVehicleModels = async (year: string, make: string) => {
  const response = await axios.get(
    `${getBaseUrl()}/statics/vehicleModels?year=${year}&make=${make}`
  );
  return response.data;
};

export const getVehicleModelDetails = async (
  year: string,
  make: string,
  model: string
) => {
  const response = await axios.get(
    `${getBaseUrl()}/statics/vehicleDetails?year=${year}&make=${make}&model=${model}`
  );
  return response.data;
};

export const getSuburbs = async (postalCode: string, name: string) => {
  const response = await axios.get(
    `${getBaseUrl()}/statics/suburbs?postCode=${postalCode}&name=${name}`
  );
  return response.data;
};
